const traditional = [
  "Jackhammers and heavy equipment",
  "Dust and debris throughout the building",
  "Closed areas for weeks or months",
  "Damaged finishes and surfaces",
  "Displaced residents and tenants",
  "Enormous cost — often $50,000+",
];

const clwizard = [
  "6–12mm micro drill points only",
  "Zero dust — zero debris",
  "Building operates completely normally",
  "No surface damage whatsoever",
  "Residents are completely unaware",
  "Fraction of the traditional cost",
];

export default function NoDemolitionSection() {
  return (
    <section id="no-demolition" className="bg-[#f0f4f8] py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#4a7fa5] font-bold uppercase tracking-widest text-sm mb-3">No Demolition</p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0a0e1a] max-w-3xl mx-auto leading-tight">
            What &ldquo;No Demolition&rdquo; Actually Means{" "}
            <span className="text-[#1a3a5c]">For Your Building</span>
          </h2>
        </div>

        {/* Comparison */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Traditional */}
          <div className="bg-[#1a0a0a] rounded-lg p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-red-900/50">
                <i className="ri-close-circle-fill text-red-400 text-lg"></i>
              </div>
              <h3 className="text-white font-extrabold text-xl">Traditional Repair</h3>
            </div>
            <ul className="flex flex-col gap-4">
              {traditional.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-close-line text-red-400 text-base"></i>
                  </span>
                  <span className="text-gray-300 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* CLWizard */}
          <div className="bg-[#0a0e1a] border-2 border-[#1a3a5c]/60 rounded-lg p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#1a3a5c]/40">
                <i className="ri-checkbox-circle-fill text-[#4a7fa5] text-lg"></i>
              </div>
              <h3 className="text-white font-extrabold text-xl">CLWizard Method</h3>
            </div>
            <ul className="flex flex-col gap-4">
              {clwizard.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#4a7fa5] text-base"></i>
                  </span>
                  <span className="text-gray-200 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
